<app-breadcrumb></app-breadcrumb>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<br>
<!--search elements-->
<div class="row ps-0">
  <div class="col-md-8">
    <div class="row" *ngIf="selectedOption=='Training Vs Group'">
      <div class="row">
        <div class="col-md-6">
          <div style="display: flex; justify-content: center;">
            <label for="email" id="trainingNameAlert" style="margin-top: 9px;"><b>Training Name : &nbsp;
              </b></label>
            <div class="col-sm-7" style="position: relative;">
              <input id="participantUserName" style="cursor: not-allowed; height: 35px;" type="text"
                class="userNametextbox" [(ngModel)]="getSelectedTrainingName" disabled>
            </div>&nbsp;&nbsp;
            <div class="col-sm-1 search-icon" (click)="searchTrainingFunction()"
               (keydown.enter)="searchTrainingFunction()" style="margin-top: 7px;">
              <i class="fa fa-search fa-1x"></i>
            </div>
          </div>
        </div>
      </div>&nbsp;&nbsp;&nbsp;&nbsp;<br><br>
      <div class="row">
        <div class="col-sm-12 group-dropdown-align text-center">
          <div class="button-continer">
            <button mat-stroked-button class="addButton" (click)="getUsers()">
              Generate
            </button>&nbsp;
            <button mat-stroked-button class="cancelButton resetButton" (click)="resetFunction()">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <br />
      </div>
    </div>
    <div class="row" *ngIf="selectedOption=='Expiry Date'">
      <div class="row">
        <div class="col-md-3" style="display: flex; justify-content: center;">
          <label for="email" id="overDue" style="margin-top: 10px;"><b>Over Due <span class="mandatory-symbol">*</span>
              :
            </b></label>
        </div>
        <div class="col-md-4" style="margin-left: -80px;">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedOverDue" (closed)="overdueSearchText=''"
            (click)="focusSearch('focus-title-search4')" (keydown.enter)="focusSearch('focus-title-search4')">
            <input type="search" id="focus-title-search4" class="dropdownsearchstyle" [(ngModel)]="overdueSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of overDueDropDown | assessmentSearch : overdueSearchText;"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="row" style="margin-top: 5px;">
        <div class="col-sm-12 group-dropdown-align text-center">
          <div class="button-continer">
            <button mat-stroked-button class="addButton " (click)="getUsers()">
              Generate
            </button>&nbsp;
            <button mat-stroked-button class="cancelButton resetButton" (click)="resetFunction()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="selectedOption=='Milestone'">
      <div class="col-md-3">
        <div><label for="email" id="groupNameAlert"><b>Category</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedTrainingCategory"
          (closed)="categorySearchText=''" (click)="focusSearch('focus-title-search3')" (keydown.enter)="focusSearch('focus-title-search3')">
          <input type="search" id="focus-title-search3" class="dropdownsearchstyle" [(ngModel)]="categorySearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onCategorySelectNew($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of categoryDropdown | assessmentSearch : categorySearchText;"
            (onSelectionChange)="onCategorySelectNew($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email" id="teaskView"><b>Task ID</b>: </label></div>
        <div style="display: flex; align-items: center;">
          <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
            [(ngModel)]="getSelectedTaskId" placeholder="Search">
          &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchTaskVwFunction()" (keydown.enter)="searchTaskVwFunction()"></span>
        </div>
      </div>
      <div class="col-md-2">
        <label for="email" id="groupNameAlert3"><b>Specify Interval</b></label>&nbsp;
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="specificIntervalVal" (change)="specificIntervalFun($event)">
            <span class="active-inActive-container" *ngIf="specificIntervalVal" style="color: green;">Yes</span>
            <span *ngIf="!specificIntervalVal" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email" id="groupNameAlert2"><b>Date Range</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedDateRangeValue" (closed)="dateRangeSearchText=''"
          (click)="focusSearch('focus-title-search2')" (keydown.enter)="focusSearch('focus-title-search2')">
          <input type="search" id="focus-title-search2" class="dropdownsearchstyle" [(ngModel)]="dateRangeSearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onCategorySelectNew($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of dateRangeValueDropdown | assessmentSearch : dateRangeSearchText;"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email" id="groupNameAlert1"><b>Interval</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="intervalSearchText=''"
          (click)="focusSearch('focus-title-search1')" (keydown.enter)="focusSearch('focus-title-search1')">
          <input type="search" id="focus-title-search1" class="dropdownsearchstyle" [(ngModel)]="intervalSearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : intervalSearchText;"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <br><br><br>
      <div class="row" d-flex align-items-center>
        <div class="col-sm-12 group-dropdown-align text-center">
          <div class="button-continer">
            <button mat-stroked-button class="addButton " (click)="getUsers()">
              Generate
            </button>&nbsp;
            <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h3 class="reports_title">Reports</h3>
    <div class="d-flex justify-content-between">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Default'}"
        (click)="moreActivityReportDetails('Default',1)" (keydown.enter)="moreActivityReportDetails('Default',1)" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
        </div>
        <p class="report_subtext">Default</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Milestone'}"
        (click)="moreActivityReportDetails('Milestone',2)" (keydown.enter)="moreActivityReportDetails('Milestone',2)" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/milestone.svg" width="16px" height="16px" alt="Milestone">
        </div>
        <p class="report_subtext">Milestone</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Training Vs Group'}"
        (click)="moreActivityReportDetails('Training Vs Group',2)" (keydown.enter)="moreActivityReportDetails('Training Vs Group',2)" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/actions.svg" width="16px" height="16px" alt="Training Vs Group">
        </div>
        <p class="report_subtext">Training Vs Group</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Unmapped Trainings'}"
        (click)="moreActivityReportDetails('Unmapped Trainings',2)" (keydown.enter)="moreActivityReportDetails('Unmapped Trainings',2)" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Unmapped Trainings">
        </div>
        <p class="report_subtext">Unmapped Trainings</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Expiry Date'}"
        (click)="moreActivityReportDetails('Expiry Date',2)" (keydown.enter)="moreActivityReportDetails('Expiry Date',2)" style=" cursor: pointer;  margin-left: 40px;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Expiry Date">
        </div>
        <p class="report_subtext">Expiry Date</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Conclusive Trail'}"
        (click)="moreActivityReportDetails('Conclusive Trail',3)" (keydown.enter)="moreActivityReportDetails('Conclusive Trail',3)" style=" cursor: pointer;  margin-left: 40px;">
        <div class="reports_block">
          <img src="../../assets/img/trail-overall.svg" width="20px" height="20px" alt="add new" />
        </div>
        <p class="report_subtext">Conclusive Audit Trail</p>
      </div>
    </div>
  </div>
</div>
&nbsp;&nbsp;
<div class="table-container" *ngIf="tableReportDataList.length == 0  && selectedOption=='Milestone'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;font-size: 24px;">
    <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"> </span>
</div>
<div class="table-container" *ngIf="selectedOption=='Milestone' && tableReportDataList.length >0">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{selectedOption}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead style="z-index:9">
        <th>
          <span>Training Name</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('taskDetails', $event,'s')" />
        </th>
        <th>
          <span>Status</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('currentStatus', $event,'s')" />
        </th>
        <th>
          <span>Version</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('version', $event,'s')" />
        </th>
        <th>
          <span>Category</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('taskType', $event,'s')" />
        </th>
        <th>
          <span>Created On</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('createdOn', $event,'d')" />
        </th>
        <th>
          <span>Started On</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('startedOn', $event,'d')" />
        </th>
        <th>
          <span>Completed On</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('completedOn', $event,'d')" />
        </th>
        <th>
          <span>Published On</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('publishedOn', $event,'d')" />
        </th>

        <th>
          <span>Review Requested On</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('reviewRequestedOn', $event,'d')" />
        </th>
        <th>
          <span>Review Completed On</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('reviewCompletedOn', $event,'d')" />
        </th>
        <th>
          <span>Approval Requested On</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('approvalRequestedOn', $event,'d')" />
        </th>
        <th>
          <span>Approval Completed On</span>
          <span class="fa-solid fa-filter" ></span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('approvalCompletedOn', $event,'d')" />
        </th>
        <th  class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems2.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index;">
        <td class="row-data">{{ listOfUsersData.taskDetails }}</td>
        <td class="row-data">{{ listOfUsersData.currentStatus }}</td>
        <td class="row-data">{{ listOfUsersData.version }}</td>
        <td class="row-data">{{ listOfUsersData.taskType }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.startedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.completedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.publishedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.reviewCompletedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.approvalCompletedOnStr}}</td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"  ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
            <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="selectedOption=='Unmapped Trainings'">
  <div class="menu-container" style="margin-top: 35px;">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{selectedOption}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead style="z-index:9">
        <th style="width:300px">
          <span>Training Name</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('trainingName', $event,'s')" />
        </th>
        <th>
          <span>Training Code</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('trainingCode', $event,'s')" />
        </th>

        <th>
          <span>Version</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('version', $event,'s')" />
        </th>

        <th style="width:300px">
          <span>Category</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('category', $event,'s')" />
        </th>
        <th style="width:300px">
          <span>Type</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('type', $event,'s')" />
        </th>

        <th style="width:300px">
          <span>Status</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('status', $event,'s')" />
        </th>
        <th style="width:300px">
          <span>Is LatestVersion</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('', $event,'s')" />
        </th>
        <th>
          <span>Is Latest Published Version</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('', $event,'s')" />
        </th>
        <th  class="sticky-col first-col"></th>
      </thead>

      <tr *ngIf="pagedItems.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
        <td class="row-data">{{ listOfUsersData.trainingName }}</td>
        <td class="row-data">{{ listOfUsersData.trainingCode }}</td>
        <td class="row-data">{{ listOfUsersData.version }}</td>
        <td class="row-data">{{ listOfUsersData.categoryCode }}</td>
        <td class="row-data">{{ listOfUsersData.type }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLatestVersion === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLatestVersion === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"  ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<div class="table-container" *ngIf="trainingsList.length == 0  && selectedOption=='Expiry Date'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;font-size: 24px;">
    <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;">
  </span>
</div>
<div *ngIf="selectedOption=='Expiry Date' && trainingsList.length>0 && showTable ">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{selectedOption}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead style="z-index:9">
        <th>
          <span>Training Name</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('trainingName', $event,'s')" />
        </th>
        <th>
          <span>Training Code</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('trainingCode', $event,'s')" />
        </th>

        <th>
          <span>Category Code</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('categoryCode', $event,'s')" />
        </th>
        <th>
          <span>Expiry In Days</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('expiryInDays', $event,'s')" />
        </th>
        <th>
          <span>Expiry Date</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('expiryDate', $event,'d')" />
        </th>

        <th>
          <span>Description</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('Description', $event,'s')" />
        </th>
        <th>
          <span>Is Latest Version</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('isLatestVersion', $event,'s')" />
        </th>
        <th>
          <span>Is Latest Published Version</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('isLatestPublishedVersion', $event,'s')" />
        </th>
        <th>
          <span>Type</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('type', $event,'s')" />
        </th>
        <th>
          <span>Total Duration</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('totalDuration', $event,'s')" />
        </th>
        <th>
          <span>Language</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('language', $event,'s')" />
        </th>
        <th>
          <span>Status</span>
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter1('status', $event,'s')" />
        </th>
        <th>
          <span>Published By</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('publishedBy', $event,'s')" />
        </th>
        <th>
          <span>Published On</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('publishedOn', $event,'d')" />
        </th>
        <th>
          <span>Updated By</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('updatedBy', $event,'s')" />
        </th>
        <th>
          <span>Updated On</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('updatedOn', $event,'d')" />
        </th>
        <th>
          <span>Created By</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('createdBy', $event,'s')" />
        </th>
        <th>
          <span>Created On</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('createdOn', $event,'d')" />
        </th>
        <th>
          <span>Last Action From Status</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('lastActionFromStatus', $event,'s')" />
        </th>
        <th>
          <span>Last Action Comments</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('lastActionComments', $event,'s')" />
        </th>
        <th>
          <span>Last Action By</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('lastActionBy', $event,'s')" />
        </th>
        <th>
          <span>Last Action On</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('lastActionOn', $event,'s')" />
        </th>
        <th>
          <span>Intimate Expiry Before In Days</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('intimateExpiryBeforeInDays', $event,'s')" />
        </th>
        <th>
          <span>Self Assignable</span>
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter1('selfAssignable', $event,'s')" />
        </th>
        <th  class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
        <td class="row-data">{{ listOfUsersData.trainingName }}</td>
        <td class="row-data">{{ listOfUsersData.trainingCode }}</td>
        <td class="row-data">{{ listOfUsersData.categoryCode }}</td>
        <td class="row-data">{{ listOfUsersData.expiryInDays }}</td>
        <td class="row-data">{{ listOfUsersData.expiryDateStr}}</td>
        <td class="row-data">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(listOfUsersData,'DESCRIPTION',listOfUsersData.description,'TMS_TRAININGS')">
              <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
              <span class="ms-1" style="color:azure;">View</span>
            </button>
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLatestVersion === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLatestVersion === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.type }}</td>
        <td class="row-data">{{ listOfUsersData.totalDuration }}</td>
        <td class="row-data">{{ listOfUsersData.language }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.publishedByName }}</td>
        <td class="row-data">{{ listOfUsersData.publishedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.updatedByName }}</td>
        <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.createdByName }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
        <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
        <td class="row-data">{{ listOfUsersData.lastActionByName }}</td>
        <td class="row-data">{{ listOfUsersData.lastActionOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.intimateExpiryBeforeInDays }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.selfAssignable === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.selfAssignable === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>

      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"  ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<div class="table-container" *ngIf="selectedOption=='Training Vs Group' && pagedItems7 && pagedItems7.length == 0">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;">
  </span>
</div>
<div *ngIf="selectedOption=='Training Vs Group'  && pagedItems7 && pagedItems7.length > 0" #captureDiv>
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{selectedOption}}</span>
      </div>
      <div class="col-sm-3 gridName-container">&nbsp;&nbsp;</div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopupForTrainingVsGroup('Excel')" (keydown.enter)="openReportPopupForTrainingVsGroup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
    </div>
  </div>
  &nbsp;&nbsp;
  <table style="overflow-x: auto;">

    <th style="position: relative;  min-width: 80px;">
      <span
        style="position: absolute; bottom: 0;  margin-left: 0px; ">Training&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        Code &nbsp;</span>
    </th>
    <th style="position: relative;  min-width: 250px; ">
      <span style=" position: absolute; bottom: 0;  margin-left: 0px; ">Training Name</span>
    </th>
    <th style="position: relative;  min-width: 60px;">
      <span style="  bottom: 0;  margin-left: 0px; ">Version</span>
    </th>
    <th style="position: relative;  min-width: 200px;">
      <span style=" position: absolute; bottom: 0;  margin-left: 8px; ">Status</span>
    </th>
    <th style="position: relative;  width:100px  ">
      <span title="Is Latest Published">Is Latest Published</span>
    </th>
    <th *ngFor="let heddingListVals of heddingListVal; let idx = index;" class="vertical-heading">
      <span title="{{heddingListVals}}">{{heddingListVals}}</span>
    </th>
    <tr *ngIf="pagedItems7.length === 0">
      <td class="row-data text-center" colspan="15">No records found</td>
    </tr>
    <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems7; let idx = index;">
      <td *ngFor="let cell of listOfUsersData; let iVal = index;"><span *ngIf="iVal <= 3">{{ cell }}</span>

        <span *ngIf="iVal==4 && cell=='Y'">
          <div class="icon-container" [ngClass]="{'green-icon': true}">
            <img src="../../assets/img/accessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </span>
        <span *ngIf="iVal==4 && cell=='N'">
          <div class="icon-container" [ngClass]="{'green-icon': true}">
            <img *ngIf="listOfUsersData.isEnabled === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </span>
        <span *ngIf="iVal > 4 && cell==1">
          <div class="icon-container" [ngClass]="{'green-icon': true}">
            <img src="../../assets/img/accessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </span>
        <span *ngIf="iVal > 4 && cell==0"></span>
      </td>
    </tr>
  </table>
  <div class="row border-top mt-1 width-cheat small paginationCell">
    <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
    </nav>

    <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
      {{ showingRowsText }}
      1-{{ perPage }} of {{ collectionSize | number }}
      <ngb-pagination class="leftpadding" (pageChange)="setPage7(pager.currentPage,$event)" [disabled]="false"
        [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
        [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
      </ngb-pagination>
      <div ngbDropdown class="d-inline-block leftpadding">
        <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic7" ngbDropdownToggle>
          {{perPage}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic7">
          <button ngbDropdownItem (click)="paginationCall7(10)">10</button>
          <button ngbDropdownItem (click)="paginationCall7(20)">20</button>
          <button ngbDropdownItem (click)="paginationCall7(50)">50</button>
        </div>
        per page
      </div>
    </nav>
    <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
    </div>
  </div>
</div>
<div class="row">
  <br /> <br /> <br />
</div>
<!--Search user grid-->
<ng-template #searchUserPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchManagerFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupData.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div  class="form-continer">
    <div class="row">
      <label for=" " style="color:red;" *ngIf="noUserAlert">Please select user</label>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName">
        <div  class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name" [(ngModel)]="searchByLastName">
        <div  class="field-icon-container"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">Designation</label></div>
        <ng-multiselect-dropdown class="multiselect-container"
          [ngStyle]="!showUserSearchGrid ? {'position': 'absolute', 'width': '24%'} : {'width': '24%'}"
          [(ngModel)]="searchByDesignationCode" [settings]="singleSelectDropdownSetting"
          [data]="designationListDropdown">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-md-4">
        <div><label for="email">Department</label></div>
        <ng-multiselect-dropdown class="multiselect-container"
          [ngStyle]="!showUserSearchGrid ? {'position': 'absolute', 'width': '24%'} : {'width': '24%'}"
          [(ngModel)]="searchByDepartmentCode" [settings]="singleSelectDropdownSetting" [data]="departmentListDropdown">
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="row" style="margin-top: 4%;">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchUser()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchManagerGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="dynamic-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i  class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th>
          <span>User Name</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>First Name</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>Last Name</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>User Full Name</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>Designation</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>Department</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>EmailAddress</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>Contact Number</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>Manager Name</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>Is Ad User</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>Is Factory User</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th>
          <span>Is Active</span>
          <span class="fa-solid fa-filter" ></span>
        </th>
        <th  class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="let listOfUsersData of getOneQmsUsersVwDetails; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersData.searchUserChildCheckBox ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input  type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersData.searchUserChildCheckBox"
                  (change)="onChildCheckBoxChanged($event, listOfUsersData, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.userName }}</td>
          <td class="row-data">{{ listOfUsersData.firstName }}</td>
          <td class="row-data">{{ listOfUsersData.lastName }}</td>
          <td class="row-data">{{ listOfUsersData.userFullName }}</td>
          <td class="row-data">{{ listOfUsersData.designation }}</td>
          <td class="row-data">{{ listOfUsersData.department }}</td>
          <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersData.contactNumber }}</td>
          <td class="row-data">{{ listOfUsersData.managerName }}</td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersData.isAdUser">
          </td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersData.isFactoryUser"> </td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersData.isActive">
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="setUser()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #searchTraining>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchTrainingFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div  class="form-continer">
    <div class="row">
      <label for=" " style="color:red;" *ngIf="noUserAlert">Please select training</label>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Training Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Name"
          [(ngModel)]="searchByTrainingName">
        <div  class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Training Code</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Code"
          [(ngModel)]="searchByTrainingCode">
        <div  class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Category</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByCategory" (closed)="categorySearchText=''"
          (click)="focusSearch('focus-title-search6')" (keydown.enter)="focusSearch('focus-title-search6')">
          <input type="search" id="focus-title-search6" class="dropdownsearchstyle" [(ngModel)]="categorySearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onCategorySelectNew($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of categoryDropdown | assessmentSearch : categorySearchText;"
            (onSelectionChange)="onCategorySelectNew($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Language</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByLanguage" (closed)="languageSearchText=''"
          (click)="focusSearch('focus-title-search5')" (keydown.enter)="focusSearch('focus-title-search5')">
          <input type="search" id="focus-title-search5" class="dropdownsearchstyle" [(ngModel)]="languageSearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onLangaugeSelectNew($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of languageDropdown | assessmentSearch : languageSearchText;"
            (onSelectionChange)="onLangaugeSelectNew($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchTrainingGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchTrainingGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
          </div>
        </th>
        <th> <span>Training Name</span> <span class="fa-solid fa-filter" ></span>
        </th>
        <th> <span>Training Code</span> <span class="fa-solid fa-filter" ></span>
        </th>
        <th> <span>Version</span> <span class="fa-solid fa-filter" ></span> </th>
        <th> <span>Category</span> <span class="fa-solid fa-filter" ></span>
        </th>
        <th> <span>Training Type</span> <span class="fa-solid fa-filter" ></span>
        </th>
        <th> <span>Language</span> <span class="fa-solid fa-filter" ></span>
        </th>
        <th  class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getTmsTrainingDetailsTableData; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchTrainingChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersVwDetails.searchTrainingChildCheckBoxs"
                  (change)="searchTrainingChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.trainingName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.trainingCode }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.version }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.categoryCode }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.type }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.language }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="addTrainingNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchTrainingFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title
      }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>

      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label  for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
            (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">

            <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label  for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
            <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label  for="email">Report Name</label>
        </div>
        <div class="col-sm-8">
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
        </div>

      </div>

    </div>

    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
          (closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')" (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle" [(ngModel)]="pdfSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel && selectedOption!='Training Vs Group'" mat-stroked-button class="addButton"
      (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="isForExcel && selectedOption=='Training Vs Group'" mat-stroked-button class="addButton"
      (click)="generateReportForTrainingVsGroup('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #searchTaskVW>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAllTaskVwFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div  class="form-continer">
    <table class="search-manager-table-container">
      <th style="min-width: 80px; text-align: center;">
        <div style="display: flex;">
          <div>
            <i  class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div style="margin-left: 5px;">
          </div>
        </div>
      </th>
      <th>
        <span>Task Id</span> <span class="fa-solid fa-filter" ></span>
        <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('taskId', $event)" />
      </th>
      <th>
        <span>Task Details</span> <span class="fa-solid fa-filter" ></span>
        <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('taskDetails', $event)" />
      </th>
      <tr class="data-row-container" *ngFor="let listOfUsersVwDetails of getTaskDetailsObj1; let idx = index;"
        [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBoxs == true">
        <td style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input  type="checkbox" style="zoom: 1.2;"
                [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                (change)="searchTaskVwChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
            </div>
          </div>
        </td>
        <td class="row-data">{{ listOfUsersVwDetails.taskId }}</td>
        <td class="row-data">{{ listOfUsersVwDetails.taskDetails }}</td>
      </tr>
    </table>
  </div>
  <div class="row">
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="addTaskVwGridDataFunction()">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelAllTaskVwFunction()">
        <i class="fa fa-repeat"></i> cancel
      </button>
    </div>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>
